var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "67", height: "50", viewBox: "0 0 67 50" }, props),
    React.createElement("path", { fill: "#E5E5E5", fillRule: "evenodd", d: "M37 50V38.82h8.92L34 20.75 22.08 38.82H31V50H16a16.5 16.5 0 1 1 1-33 16.8 16.8 0 0 1 0-.5 16.5 16.5 0 1 1 33 .5h.5a16.5 16.5 0 0 1 .5 33H37z" })
  );
});